
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'nasal_cavity_and_paranasal_sinus_tumors',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/nasal_cavity_and_paranasal_sinus_tumors.vue